export default window._env_ || {
  REACT_APP_ADMIN_ENDPOINT: 'http://localhost:8000/admin-api',
  REACT_APP_SCHEDULING_ENDPOINT: 'http://localhost:8100/scheduling-api',
  REACT_APP_SSO_PORTAL_ENDPOINT: 'http://localhost:9002/portal',
  REACT_APP_SSO_AUTH_SERVER_ENDPOINT: 'http://localhost:9000/auth-server',
  REACT_APP_SSO_USER_ENDPOINT: 'http://localhost:9003/user-service',
};
